import React, { createContext, useContext, useEffect, useState } from "react";

const TRANSLATIONS = {
  en: {
    "app.name": "Rail CRM",
    "app.subtitle": "Transit & Rail • CRM",
    "nav.dashboard": "Dashboard",
    "nav.installedBase": "Installed Base",
    "nav.opportunities": "Opportunities",
    "nav.accountPlans": "Account Plans",
    "nav.pipeline": "Pipeline",
    "nav.objectives": "Objectives",
    "nav.visits": "Visits & Actions",
    "nav.contacts": "Contacts",
    "nav.prices": "Price History",
    "nav.competitors": "Competitors",
    "nav.map": "Map",
    "nav.settings": "Settings",
    "nav.admin": "Admin",
    "nav.logout": "Logout",
    "login.title": "Sign in",
    "login.subtitle": "Internal CRM",
    "login.email": "Email",
    "login.password": "Password",
    "login.submit": "Sign in",
    "login.demo": "Demo accounts",
    "dashboard.title": "Operational dashboard",
    "dashboard.subtitle": "Real-time installed-base, opportunities, pipeline",
    "kpi.total_units": "Total units",
    "kpi.wabtec_units": "Wabtec units",
    "kpi.share": "Wabtec share",
    "kpi.addressable": "Addressable",
    "kpi.platforms": "Platforms",
    "kpi.operators": "Operators",
    "kpi.cities": "Cities",
    "kpi.trainsets": "Trainsets",
    "pipeline.m1": "M1 — Theoretical",
    "pipeline.m2": "M2 — Addressable",
    "pipeline.m3": "M3 — Weighted",
    "pipeline.active": "Active method",
    "pipeline.byStatus": "Opportunities by OVH status",
    "pipeline.byYear": "Pipeline by year (Active €)",
    "pipeline.byOperator": "Top operators (Active €)",
    "pipeline.bySub": "Top sub-systems (Active €)",
    "filters.all": "All",
    "filters.city": "City",
    "filters.operator": "Operator",
    "filters.platform": "Platform",
    "filters.sub": "Sub-system",
    "filters.supplier": "Supplier",
    "filters.status": "OVH Status",
    "filters.clear": "Clear",
    "table.id": "ID",
    "table.city": "City",
    "table.operator": "Operator",
    "table.platform": "Platform",
    "table.sub": "Sub-system",
    "table.qty": "Qty",
    "table.supplier": "Supplier",
    "table.wabtec": "Wabtec?",
    "table.unitPrice": "Unit price",
    "table.m1": "M1 (€)",
    "table.m2": "M2 (€)",
    "table.m3": "M3 (€)",
    "table.active": "Active (€)",
    "table.ovh": "Next OVH",
    "table.status": "Status",
    "table.priceSource": "Price source",
    "whatif.title": "What-if simulator",
    "whatif.method": "Method",
    "whatif.probWabtec": "Probability — Wabtec already in",
    "whatif.probTbc": "Probability — Supplier TBC",
    "whatif.probComp": "Probability — Competitor",
    "whatif.timingNow": "Timing — Now/Past",
    "whatif.timingShort": "Timing — Hot (≤2y)",
    "whatif.timingMid": "Timing — Warm (3-5y)",
    "whatif.timingLong": "Timing — Cold (>5y)",
    "whatif.run": "Run simulation",
    "whatif.reset": "Reset",
    "whatif.result": "Simulation result",
    "whatif.delta": "Δ vs current",
    "ap.title": "Account Plans",
    "ap.subtitle": "Strategic per-operator plays — sourced from Roadmap v4.1",
    "ap.strengths": "Strengths",
    "ap.risks": "Risks",
    "ap.milestones": "Quarterly milestones",
    "ap.exportPdf": "Export PDF",
    "ap.priority": "Priority",
    "pipelineGrid.title": "Pipeline 2026–2030",
    "pipelineGrid.subtitle": "Active method (€) by operator × year",
    "pipelineGrid.total": "TOTAL",
    "kanban.subtitle": "Drag opportunities between OVH stages — manual reclassification persists",
    "visits.title": "Visits & Actions",
    "visits.newBtn": "+ New visit",
    "visits.date": "Date",
    "visits.subject": "Subject",
    "visits.summary": "Summary",
    "visits.nextAction": "Next action",
    "visits.due": "Due",
    "visits.priority": "Priority",
    "visits.status": "Status",
    "visits.owner": "Owner",
    "visits.linkedOpp": "Linked OPP",
    "visits.save": "Save",
    "visits.cancel": "Cancel",
    "contacts.title": "Contacts",
    "contacts.score": "Relationship",
    "contacts.dm": "Decision maker",
    "contacts.newBtn": "+ New contact",
    "prices.title": "Price History",
    "prices.subtitle": "Latest price per sub-system feeds opportunity calculations",
    "prices.newBtn": "+ New price",
    "prices.date": "Date",
    "prices.price": "Price",
    "prices.currency": "Currency",
    "prices.source": "Source",
    "prices.notes": "Notes",
    "competitors.title": "Competitive intelligence",
    "competitors.subtitle": "Supplier × sub-system matrix and Wabtec share by sub-system",
    "competitors.matrix": "Supplier × Sub-system (qty)",
    "competitors.share": "Wabtec share by sub-system",
    "map.title": "Turkey — Installed base map",
    "map.subtitle": "Pipeline value (Active €) by city",
    "settings.title": "Settings",
    "settings.subtitle": "Calculation parameters — changes trigger an automatic recompute of all 880+ opportunities.",
    "settings.method": "Active method",
    "settings.probabilities": "Probabilities",
    "settings.timing": "Timing factors",
    "settings.fx": "FX (informational)",
    "settings.save": "Save & recompute",
    "settings.year": "Current year",
    "admin.title": "Admin",
    "admin.subtitle": "Data import & maintenance",
    "admin.reimport": "Re-import Excel files",
    "admin.exportCrm": "Export → CRM v5.x .xlsx",
    "admin.exportRoadmap": "Export → Roadmap .xlsx",
    "admin.dataIntegrity": "Data integrity",
    "comments.title": "Comments & activity",
    "comments.placeholder": "Add a comment… (⌘/Ctrl+Enter to send)",
    "comments.empty": "No comments or activity yet.",
    "comments.confirmDelete": "Delete this comment?",
    "comments.open": "Comments",
    "comments.kind.comment": "Comment",
    "comments.kind.create": "Created",
    "comments.kind.update": "Updated",
    "comments.kind.delete": "Deleted",
    "activity.title": "Recent activity",
    "activity.viewAll": "Open Plans",
    "activity.empty": "No activity yet.",
    "activity.justNow": "just now",
    "activity.minAbbr": "m",
    "activity.hAbbr": "h",
    "activity.dAbbr": "d",
    "country.switcher": "Country",
    "country.noData": "No data",
    "country.empty.title": "No data for this country yet",
    "country.empty.hint": "Import the local installed-base Excel from the Admin page to get started.",
    "export.title": "Custom export",
    "export.subtitle": "Pick the columns you need. Active filters are reported in the file banner.",
    "export.activeFilters": "Active filters",
    "export.columns": "Columns",
    "export.all": "Select all",
    "export.none": "Clear",
    "export.download": "Download",
    "export.button": "Export",
    "ib.summaryRows": "Rows shown",
    "ib.summaryTotal": "Total units",
    "ib.summaryWabtec": "Wabtec units",
    "ib.newBtn": "+ New entry",
    "ib.editTitle": "Edit",
    "ib.newTitle": "New installed-base entry",
    "ib.confirmDelete": "Delete this installed-base row? Opportunities will be recomputed.",
    "ib.subtitle": "1,096+ equipment items across 50 platforms",
    "ap.newBtn": "+ New plan",
    "ap.editTitle": "Edit",
    "ap.newTitle": "New account plan",
    "ap.nameUnique": "Name (unique)",
    "ap.totalUnits": "Total units",
    "ap.wabtecUnits": "Wabtec units",
    "ap.sharePct": "Share %",
    "ap.addressable": "Addressable",
    "ap.strengthsEn": "Strengths (EN)",
    "ap.strengthsFr": "Strengths (FR)",
    "ap.risksEn": "Risks (EN)",
    "ap.risksFr": "Risks (FR)",
    "ap.addRow": "Add row",
    "ap.confirmDelete": "Delete this account plan?",
    "ap.noMilestones": "No milestones yet.",
    "ap.saveChanges": "Save changes",
    "ap.createPlan": "Create plan",
    "ap.empty": "No account plans yet",
    "ap.createFirst": "Create the first one",
    "opp.subtitle": "3-method pipeline — Theoretical / Addressable / Weighted",
    common: { yes: "Yes", no: "No", loading: "Loading…", save: "Save", cancel: "Cancel", delete: "Delete", edit: "Edit", from: "from", to: "to", lang: "FR" },
  },
  fr: {
    "app.name": "Rail CRM",
    "app.subtitle": "Transit & Rail • CRM",
    "nav.dashboard": "Tableau de bord",
    "nav.installedBase": "Base installée",
    "nav.opportunities": "Opportunités",
    "nav.accountPlans": "Plans de compte",
    "nav.pipeline": "Pipeline",
    "nav.objectives": "Mes objectifs",
    "nav.visits": "Visites & Actions",
    "nav.contacts": "Contacts",
    "nav.prices": "Historique prix",
    "nav.competitors": "Concurrents",
    "nav.map": "Carte",
    "nav.settings": "Paramètres",
    "nav.admin": "Admin",
    "nav.logout": "Déconnexion",
    "login.title": "Connexion",
    "login.subtitle": "CRM interne",
    "login.email": "Email",
    "login.password": "Mot de passe",
    "login.submit": "Se connecter",
    "login.demo": "Comptes de démo",
    "dashboard.title": "Tableau de bord opérationnel",
    "dashboard.subtitle": "Base installée, opportunités, pipeline en temps réel",
    "kpi.total_units": "Équipements totaux",
    "kpi.wabtec_units": "Wabtec installé",
    "kpi.share": "Part Wabtec",
    "kpi.addressable": "Adressable",
    "kpi.platforms": "Plateformes",
    "kpi.operators": "Opérateurs",
    "kpi.cities": "Villes",
    "kpi.trainsets": "Rames",
    "pipeline.m1": "M1 — Théorique",
    "pipeline.m2": "M2 — Adressable",
    "pipeline.m3": "M3 — Pondéré",
    "pipeline.active": "Méthode active",
    "pipeline.byStatus": "Opportunités par statut OVH",
    "pipeline.byYear": "Pipeline par année (Actif €)",
    "pipeline.byOperator": "Top opérateurs (Actif €)",
    "pipeline.bySub": "Top sous-systèmes (Actif €)",
    "filters.all": "Tous",
    "filters.city": "Ville",
    "filters.operator": "Opérateur",
    "filters.platform": "Plateforme",
    "filters.sub": "Sous-système",
    "filters.supplier": "Fournisseur",
    "filters.status": "Statut OVH",
    "filters.clear": "Effacer",
    "table.id": "ID",
    "table.city": "Ville",
    "table.operator": "Opérateur",
    "table.platform": "Plateforme",
    "table.sub": "Sous-système",
    "table.qty": "Qté",
    "table.supplier": "Fournisseur",
    "table.wabtec": "Wabtec?",
    "table.unitPrice": "Prix unit.",
    "table.m1": "M1 (€)",
    "table.m2": "M2 (€)",
    "table.m3": "M3 (€)",
    "table.active": "Actif (€)",
    "table.ovh": "Prochain OVH",
    "table.status": "Statut",
    "table.priceSource": "Source prix",
    "whatif.title": "Simulateur What-if",
    "whatif.method": "Méthode",
    "whatif.probWabtec": "Probabilité — Wabtec déjà installé",
    "whatif.probTbc": "Probabilité — Fournisseur TBC",
    "whatif.probComp": "Probabilité — Concurrent",
    "whatif.timingNow": "Timing — Maintenant/Passé",
    "whatif.timingShort": "Timing — Hot (≤2 ans)",
    "whatif.timingMid": "Timing — Warm (3-5 ans)",
    "whatif.timingLong": "Timing — Cold (>5 ans)",
    "whatif.run": "Lancer simulation",
    "whatif.reset": "Réinitialiser",
    "whatif.result": "Résultat de simulation",
    "whatif.delta": "Δ vs actuel",
    "ap.title": "Plans de compte",
    "ap.subtitle": "Plans stratégiques par opérateur — issus du Roadmap v4.1",
    "ap.strengths": "Atouts",
    "ap.risks": "Risques",
    "ap.milestones": "Étapes trimestrielles",
    "ap.exportPdf": "Exporter PDF",
    "ap.priority": "Priorité",
    "pipelineGrid.title": "Pipeline 2026–2030",
    "pipelineGrid.subtitle": "Méthode active (€) par opérateur × année",
    "pipelineGrid.total": "TOTAL",
    "kanban.subtitle": "Glissez les opportunités entre statuts OVH — le reclassement manuel est conservé",
    "visits.title": "Visites & Actions",
    "visits.newBtn": "+ Nouvelle visite",
    "visits.date": "Date",
    "visits.subject": "Sujet",
    "visits.summary": "Compte-rendu",
    "visits.nextAction": "Action suivante",
    "visits.due": "Échéance",
    "visits.priority": "Priorité",
    "visits.status": "Statut",
    "visits.owner": "Propriétaire",
    "visits.linkedOpp": "OPP liée",
    "visits.save": "Enregistrer",
    "visits.cancel": "Annuler",
    "contacts.title": "Contacts",
    "contacts.score": "Relation",
    "contacts.dm": "Décideur",
    "contacts.newBtn": "+ Nouveau contact",
    "prices.title": "Historique prix",
    "prices.subtitle": "Le dernier prix par sous-système alimente le calcul d'opportunités",
    "prices.newBtn": "+ Nouveau prix",
    "prices.date": "Date",
    "prices.price": "Prix",
    "prices.currency": "Devise",
    "prices.source": "Source",
    "prices.notes": "Notes",
    "competitors.title": "Intelligence concurrentielle",
    "competitors.subtitle": "Matrice fournisseur × sous-système et part Wabtec par sous-système",
    "competitors.matrix": "Fournisseur × Sous-système (qté)",
    "competitors.share": "Part Wabtec par sous-système",
    "map.title": "Türkiye — Carte de la base installée",
    "map.subtitle": "Valeur pipeline (Actif €) par ville",
    "settings.title": "Paramètres",
    "settings.subtitle": "Paramètres de calcul — toute modification déclenche un recalcul automatique des 880+ opportunités.",
    "settings.method": "Méthode active",
    "settings.probabilities": "Probabilités",
    "settings.timing": "Coefficients timing",
    "settings.fx": "FX (informatif)",
    "settings.save": "Enregistrer & recalculer",
    "settings.year": "Année courante",
    "admin.title": "Admin",
    "admin.subtitle": "Import des données & maintenance",
    "admin.reimport": "Ré-importer les fichiers Excel",
    "admin.exportCrm": "Exporter → CRM v5.x .xlsx",
    "admin.exportRoadmap": "Exporter → Roadmap .xlsx",
    "admin.dataIntegrity": "Intégrité des données",
    "comments.title": "Commentaires & activité",
    "comments.placeholder": "Ajouter un commentaire… (⌘/Ctrl+Entrée pour envoyer)",
    "comments.empty": "Aucun commentaire ni activité pour le moment.",
    "comments.confirmDelete": "Supprimer ce commentaire ?",
    "comments.open": "Commentaires",
    "comments.kind.comment": "Commentaire",
    "comments.kind.create": "Créé",
    "comments.kind.update": "Modifié",
    "comments.kind.delete": "Supprimé",
    "activity.title": "Activité récente",
    "activity.viewAll": "Voir Plans",
    "activity.empty": "Aucune activité pour le moment.",
    "activity.justNow": "à l'instant",
    "activity.minAbbr": " min",
    "activity.hAbbr": " h",
    "activity.dAbbr": " j",
    "country.switcher": "Pays",
    "country.noData": "Vide",
    "country.empty.title": "Pas encore de données pour ce pays",
    "country.empty.hint": "Importez le fichier Excel local depuis la page Admin pour commencer.",
    "export.title": "Export personnalisé",
    "export.subtitle": "Sélectionnez les colonnes souhaitées. Les filtres actifs sont indiqués en en-tête du fichier.",
    "export.activeFilters": "Filtres actifs",
    "export.columns": "Colonnes",
    "export.all": "Tout sélectionner",
    "export.none": "Aucune",
    "export.download": "Télécharger",
    "export.button": "Exporter",
    "ib.summaryRows": "Lignes affichées",
    "ib.summaryTotal": "Équipements totaux",
    "ib.summaryWabtec": "Équipements Wabtec",
    "ib.newBtn": "+ Nouvelle entrée",
    "ib.editTitle": "Modifier",
    "ib.newTitle": "Nouvelle entrée base installée",
    "ib.confirmDelete": "Supprimer cette ligne ? Les opportunités seront recalculées.",
    "ib.subtitle": "1 096+ équipements répartis sur 50 plateformes",
    "ap.newBtn": "+ Nouveau plan",
    "ap.editTitle": "Modifier",
    "ap.newTitle": "Nouveau plan de compte",
    "ap.nameUnique": "Nom (unique)",
    "ap.totalUnits": "Équipements totaux",
    "ap.wabtecUnits": "Équipements Wabtec",
    "ap.sharePct": "Part %",
    "ap.addressable": "Adressable",
    "ap.strengthsEn": "Atouts (EN)",
    "ap.strengthsFr": "Atouts (FR)",
    "ap.risksEn": "Risques (EN)",
    "ap.risksFr": "Risques (FR)",
    "ap.addRow": "Ajouter ligne",
    "ap.confirmDelete": "Supprimer ce plan de compte ?",
    "ap.noMilestones": "Aucune étape pour le moment.",
    "ap.saveChanges": "Enregistrer",
    "ap.createPlan": "Créer le plan",
    "ap.empty": "Aucun plan de compte",
    "ap.createFirst": "Créer le premier plan",
    "opp.subtitle": "Pipeline 3 méthodes — Théorique / Adressable / Pondéré",
    common: { yes: "Oui", no: "Non", loading: "Chargement…", save: "Enregistrer", cancel: "Annuler", delete: "Supprimer", edit: "Modifier", from: "du", to: "au", lang: "EN" },
  },
};

const I18nCtx = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("wabtec_lang") || "en");
  useEffect(() => {
    localStorage.setItem("wabtec_lang", lang);
  }, [lang]);
  const t = (key) => {
    const dict = TRANSLATIONS[lang] || {};
    // Direct flat lookup first
    if (key in dict) return dict[key];
    // Nested fallback (for "common.yes" etc.)
    if (key.includes(".")) {
      const path = key.split(".");
      let v = dict;
      for (const p of path) v = v?.[p];
      if (v != null) return v;
    }
    return key;
  };
  const toggle = () => setLang(lang === "en" ? "fr" : "en");
  return <I18nCtx.Provider value={{ lang, t, toggle, setLang }}>{children}</I18nCtx.Provider>;
}

export const useI18n = () => useContext(I18nCtx);
